import { render, staticRenderFns } from "./waterLinks.vue?vue&type=template&id=0fb3fee2&scoped=true&"
import script from "./waterLinks.vue?vue&type=script&lang=ts&"
export * from "./waterLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb3fee2",
  null
  
)

export default component.exports